import 'react-datepicker/dist/react-datepicker.css';
import './CreateBriefing.css';

import React, { useEffect, useState } from 'react';
import {
  createBriefing,
  editBriefing,
} from '../../../../services/briefingService';

import { selectUser } from '../../../../redux/reducers/userReducer';
import { useLoader } from '../../../../hooks/useLoader';
import { useSelector } from 'react-redux';

function CreateBriefing({ briefing, backPress }) {
  const [title, setTitle] = useState<string>(briefing?.title || '');

  const user = useSelector(selectUser);
  const { showLoading } = useLoader();

  const createBriefingAPi = async () => {
    if (!title) {
      return;
    }
    try {
      showLoading(true);
      if (briefing) {
        const data = await editBriefing({
          briefingId: briefing.id,
          email: user.data?.user.user_id || '',
          title,
        });
      } else {
        const data = await createBriefing({
          email: user.data?.user.user_id || '',
          title,
        });
      }
      backPress();
      showLoading(false);
    } catch (error) {
      showLoading(false);
      if (error.response.data.message) {
        alert(error.response.data.message);
      } else {
        alert("Something went wrong");
      }
    }
  };

  return (
    <div>
      <div className='header-container'>
        <h2>Create Briefing</h2>
        <span>
          <button
            className='save-a-Briefing'
            onClick={() => {
              backPress();
            }}
            style={{
              borderRadius: '100px',
              border: '1px solid #934848',
              color: '#934848',
              fontSize: 16,
              fontWeight: 700,
            }}
          >
            Close
          </button>
          <button
            className='save-a-Briefing'
            onClick={() => {
              createBriefingAPi();
            }}
            disabled={!title}
            style={{
              marginLeft: 10,
              backgroundColor: !!title ? '#0B335E' : '#8FA1B5',
              border: 'none',
              color: '#E7EBEF',
              fontSize: 16,
              fontWeight: 700,
            }}
          >
            Save
          </button>
        </span>
      </div>

      <div>
        <div className='label-row'>
          <span
            style={{
              fontSize: 16,
              fontWeight: 700,
              fontFamily: 'Nunito Sans',
              color: '#161616',
            }}
          >
            Title
          </span>
        </div>

        <div
          className='input-row'
          style={{ position: 'relative', display: 'inline-block' }}
        >
          <input
            type='text'
            id='meeting-time'
            name='meeting-time'
            value={title}
            placeholder='Enter title'
            style={{
              width: 300,
              marginTop: 5,
              paddingRight: '30px',
              backgroundColor: title ? 'white' : 'transparent',
              borderRadius: '16px',
              color: '#161616',
              fontFamily: 'Nunito Sans',
              fontWeight: 600,
            }}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
      </div>

      <div
        style={{
          marginTop: 50,
          fontSize: 16,
          fontWeight: 700,
          fontFamily: 'Nunito Sans',
          color: '#161616',
        }}
      >
        Briefing URL
        <div>
          <input
            style={{
              width: 320,
              marginTop: 5,
              borderRadius: '16px',
              backgroundColor: '#FFFFFF',
              color: '#949494',
            }}
            type='text'
            value='www.eurointelligence.com/briefing'
            disabled
          />
        </div>
      </div>
    </div>
  );
}

export default CreateBriefing;
